module.exports = __webpack_public_path__ + "img/Frequency35MHz.f21f55c6.svg";